import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context){
	var base = '.b-textSlider';
	$(base, context).each(function(i, el){
		setTimeout(function() {
			var slider = new Swiper (el.querySelector('.b-textSlider-container'), {
				// direction: 'vertical',
				slidesPerView: 1,
				spaceBetween: 0,
				effect: 'fade',
				loop: true,
				slideClass: 'b-textSlider-item',
				autoplay: {
					delay: 4000,
				},
			});
		});
	});
});